import { Component, HostListener, OnInit } from "@angular/core";
import { Customer } from "../../../objects/customers/customer";
import { PaginationInstance } from "ngx-pagination";
import { ActivatedRoute } from "@angular/router";
import { CustomerService } from "../../../services/customerService";
import { CustomerSearchRequest } from "../../../objects/requests/customerSearchRequest";
import { BlurUtil } from "../../../common/utils/blurUtil";
import { OrderBy } from "ngx-odata-v4";

/**
 * Created by alex.y on 9/7/2017.
 */
@Component({
    selector: 'customer',
    templateUrl: 'customerManagement.component.html',
    moduleId: module.id.toString()
})
export class CustomerManagementComponent implements OnInit {
    public query: string = "";
    public loading: boolean = false;

    public customers: Customer[] = [];

    public idToBlur: string = "customer-management";

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private route: ActivatedRoute, public customerService: CustomerService) {

    }

    @HostListener('window:popstate', ['$event'])
    unBlurMenu(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
        this.config.totalItems = this.route.snapshot.data.customers.TotalCount;
        this.customers = this.route.snapshot.data.customers.Items;
    }

    public search(): void {
        this.loading = true;
        let field = 'Id';
        if(!String.isNullOrEmpty(this.query))
            field = '_score';
        this.customerService.search(new CustomerSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            OrderBy: {PropertyName: field, OrderBy: OrderBy.Desc},
            FillOrders: false
        })).then(users => {
            this.customers = users.Data.Items;
            this.config.totalItems = users.Data.TotalCount;

            document.getElementById('mainPanel').scrollTop = 0;
            this.loading = false;
        }).catch(response => {
            this.customers.splice(0, this.customers.length);
            this.loading = false;
        });
    }

    public createCustomer(): void {
        // this.customerModalComponent.show(new User());
    }

    public onCustomerSaved(customer: Customer): void {
        let existingCustomer = this.customers.find(x => x.Id == customer.Id);

        if (existingCustomer != null) {
            if (customer.Orders.length == 0 && existingCustomer.Orders.length > 0)
                customer.Orders = existingCustomer.Orders;

            Object.assign(existingCustomer, customer);
        } else {
            this.customers.unshift(customer);
            this.customers.pop();
            this.config.totalItems += 1;
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/customerManagement/customerManagement.component.ts